import React from "react";
import Helmet from "react-helmet";

import * as styles from "./index.module.scss";

import { Col, Collapse, Row } from "antd";

import Footer from "@components/footer";
import Header from "@components/header";
import TextCenterBanner from "@components/textCenterBanner";
import { useI18n } from "@src/i18n";

import phoneImg from "@src/images/serviceRules/Rectangle4386.png";
import pcImg from "@src/images/serviceRules/Rectangle4387.png";

const ServiceRulesPage = () => {
  const { t } = useI18n();
  const localizedRenderDatas = t("termsPage.sections");

  return (
    <div className={styles.serviceRulesPage}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("termsPage.title")}</title>
      </Helmet>
      <Header />

      <TextCenterBanner pcImg={pcImg} phoneImg={phoneImg} text={t("termsPage.banner")} />
      <Row>
        <Col xs={0} sm={0} md={24}>
          <div className={styles.list}>
            {localizedRenderDatas.map((item) => {
              return (
                <div className={styles.listItem} key={item.title}>
                  <div className={styles.itemTitle}>{item.title}</div>
                  {item.details.map((text, index) => (
                    <div className={styles.itemDetail} key={index}>
                      {text}
                    </div>
                  ))}
                  {item.intro && (
                    <div className={styles.intro}>
                      <div className={styles.introTitle}>{t("termsPage.introLabel")}</div>
                      {item.intro.map((intro) => {
                        return <div key={intro}>{intro}</div>;
                      })}
                    </div>
                  )}
                  {item.anotherDetails && (
                    <div className={styles.details2}>
                      {item.anotherDetails.map((text) => (
                        <div className={styles.itemDetail} key={text}>
                          {text}
                        </div>
                      ))}
                    </div>
                  )}

                  {item.date && (
                    <div className={styles.date}>
                      {item.date.map((date) => (
                        <div key={date}>{date}</div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Col>
        <Col xs={24} sm={24} md={0}>
          <div className={styles.smallList}>
            <Collapse
              defaultActiveKey={[0]}
              expandIconPosition="right"
              ghost
              bordered="false"
            >
              {localizedRenderDatas.map((item) => (
                <Collapse.Panel header={item.title} key={item.title}>
                  {/* <div className={styles.itemTitle}>{item.title}</div> */}
                  {item.details.map((text, index) => (
                    <div className={styles.itemDetail} key={index}>
                      {text}
                    </div>
                  ))}
                  {item.intro && (
                    <div className={styles.intro}>
                      <div className={styles.introTitle}>{t("termsPage.introLabel")}</div>
                      {item.intro.map((intro, index) => {
                        return <div key={intro}>{intro}</div>;
                      })}
                    </div>
                  )}
                  {item.anotherDetails && (
                    <div className={styles.details2}>
                      {item.anotherDetails.map((text) => (
                        <div className={styles.itemDetail} key={text}>
                          {text}
                        </div>
                      ))}
                    </div>
                  )}

                  {item.date && (
                    <div className={styles.date}>
                      {item.date.map((date) => (
                        <div key={date}>{date}</div>
                      ))}
                    </div>
                  )}
                </Collapse.Panel>
              ))}
            </Collapse>
          </div>
        </Col>
      </Row>
      <Footer />
    </div>
  );
};

export default ServiceRulesPage;
